import React, { useState } from "react";
import "./Commercial.css";
import Footer from "./Footer";
import img1 from "../assets/01-cylinder-head-side1.jpg";
import img2 from "../assets/02-crankcase-side1.jpg";
import img4 from "../assets/04-swingarm.jpg";
import img5 from "../assets/05-frame-assm.jpg";

const products = [
    {
        title: "Cylinder Head",
        desc: "Top cover of combustion chamber of engine.",
        img: img1,
        type: "ICE",
        process: "LPDC",
        weight: "1.6 to 4.4 Kg",
        category: "Engine",
    },
    {
        title: "Crank Case Lower",
        desc: "Houses the crank shaft and related assembly elements.",
        img: img2,
        type: "ICE",
        process: "HPDC",
        weight: "CCL: 1.7-4.2 kg, CCR: 1.56-2.6 kg",
        category: "Engine",
    },
    {
        title: "Rear Swing Arm",
        desc: "Connects wheel to chain sprocket assembly.",
        img: img4,
        type: "Chassis",
        process: "HPDC",
        weight: "6 Kg",
        category: "Structural",
    },
    {
        title: "Frame",
        desc: "Connects wheel to chain sprocket assembly.",
        img: img5,
        type: "Chassis",
        process: "GDC",
        weight: "3.5 Kg",
        category: "Structural",
    },
];

function TwoWheelers() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    const categories = [
        {
            key: "Engine",
            title: "Engine",
            desc: "Capability to manufacture a range of aluminium engine components from 1.6 kg to 4.4 kg through LPDC. Below are just a few examples:",
        },
        { key: "Structural", title: "Structural" },
    ];

    return (
        <section id="two-wh">
            <div className="cv-container">

                <h2 className="cv-title">Others</h2>
                <div className="cv-underline"></div>

                <p className="cv-desc">
                    We produce compact, precision-engineered castings for speed and reliability, beyond commercial and passenger vehicles.
                </p>

              {categories.map((category, catIndex) => (
    <div className="cv-category" key={category.key}>
        <h3 className="cv-category-title">
            {String(catIndex + 1).padStart(2, "0")}. {category.title}
        </h3>

                        {category.desc && (
                            <p className="cv-category-desc">
                                {category.desc}
                            </p>
                        )}

                        <div className="cv-grid">
                            {products
                                .filter(
                                    (item) =>
                                        item.category === category.key
                                )
                                .map((item, index) => (
                                    <div
                                        className="cv-card"
                                        key={index}
                                    >
                                        <div
                                            className="cv-image"
                                            style={
                                                item.img
                                                    ? {
                                                          backgroundImage: `url(${item.img})`,
                                                          backgroundSize: "cover",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundPosition: "center",
                                                      }
                                                    : {}
                                            }
                                        />

                                        <div className="cv-overlay">
                                            <h4>{item.title}</h4>
                                            <p>{item.desc}</p>

                                            <span
                                                className="cv-link"
                                                onClick={() =>
                                                    setSelectedProduct(item)
                                                }
                                            >
                                                View Specifications ↗
                                            </span>
                                        </div>

                                        <div className="cv-label">
                                            {item.title}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}

                {selectedProduct && (
                    <div
                        className="modal-backdrop"
                        onClick={() =>
                            setSelectedProduct(null)
                        }
                    >
                        <div
                            className="modal-box"
                            onClick={(e) =>
                                e.stopPropagation()
                            }
                        >
                            <span
                                className="modal-close"
                                onClick={() =>
                                    setSelectedProduct(null)
                                }
                            >
                                ✕
                            </span>

                            <h5 className="modal-section-title">
                                Overview
                            </h5>

                            <div className="modal-overview">
                                <div
                                    className="modal-img"
                                    style={
                                        selectedProduct.img
                                            ? {
                                                  backgroundImage: `url(${selectedProduct.img})`,
                                                  backgroundSize: "cover",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundPosition: "center",
                                              }
                                            : {}
                                    }
                                ></div>

                                <div>
                                    <h3>
                                        {selectedProduct.title}
                                    </h3>
                                    <p>
                                        {selectedProduct.desc}
                                    </p>
                                </div>
                            </div>

                            <h5 className="modal-section-title">
                                Features
                            </h5>

                            <div className="modal-table">
                                <div>
                                    <span>
                                        ICE / BEV / Chasis / Cabin
                                    </span>
                                    <span>
                                        {selectedProduct.type}
                                    </span>
                                </div>

                                <div>
                                    <span>
                                        Casting Process Used
                                    </span>
                                    <span>
                                        {selectedProduct.process}
                                    </span>
                                </div>

                                <div>
                                    <span>Weight (Kg)</span>
                                    <span>
                                        {selectedProduct.weight}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <Footer />
        </section>
    );
}

export default TwoWheelers;
